import { QuestionBase } from './question-base.model';

export class CustomFormQuestion extends QuestionBase<string> {
    controlType = 'custom_form_component';
    resource: string;
    bannerJson: any;
    item_key: string;
    selector: any;

    constructor(options: {} = {}) {
        super(options);
        this.resource = options['resource'];
        this.bannerJson = options['bannerJson'];
        this.item_key = options["item_key"] || "";
        this.selector = options['selector']

    }
}
